// frontend/src/api/axiosConfig.js

import axios from 'axios';
import { auth } from '../firebase';

// Get backend URL from environment
// CRITICAL: This must be a PUBLIC URL, not internal Railway addresses
// Internal addresses (*.railway.internal) don't work in browsers
let baseURL = process.env.BACKEND_URL;

// Use relative path if no backend URL, if it's an internal address, or if it's an invalid value
const invalidValues = ['undefined', 'null', '', null, undefined];
if (!baseURL ||
    invalidValues.includes(baseURL) ||
    baseURL.includes('.railway.internal')) {
  baseURL = ''; // This will use relative paths, proxy routes /api/* to backend
}


const instance = axios.create({
  baseURL,
});

// Automatically attach Firebase token to requests
instance.interceptors.request.use(async (config) => {
  try {
    // Get the current user from Firebase auth
    const currentUser = auth.currentUser;
    if (currentUser) {
      // Get a fresh token from Firebase
      const token = await currentUser.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    // Error getting Firebase token - continuing without auth
  }
  return config;
});

// Response interceptor to handle legal acceptance requirement
let legalModalShown = false; // Debounce guard to prevent multi-trigger

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if this is a legal acceptance required error
    if (error.response?.status === 403 &&
        error.response?.data?.code === 'LEGAL_ACCEPTANCE_REQUIRED' &&
        !legalModalShown) {

      // Multi-tab coordination: check if modal already open in another tab
      const modalOpenInOtherTab = localStorage.getItem('legalModalOpen') === 'true';

      if (!modalOpenInOtherTab) {
        legalModalShown = true; // Set guard to prevent multiple modals in same tab
        localStorage.setItem('legalModalOpen', 'true'); // Coordinate across tabs

        // Dispatch custom event that App.js will listen for
        window.dispatchEvent(new CustomEvent('legal-acceptance-required', {
          detail: error.response.data.details
        }));

        // Reset guards after modal is handled (30 seconds safety timeout)
        setTimeout(() => {
          legalModalShown = false;
          localStorage.removeItem('legalModalOpen');
        }, 30000);
      }
    }

    return Promise.reject(error);
  }
);

// Helper function to get backend URL with proper fallback
export const getBackendUrl = () => {
  const url = process.env.BACKEND_URL;
  const invalidValues = ['undefined', 'null', '', null, undefined];

  if (!url || invalidValues.includes(url) || url.includes('.railway.internal')) {
    // In production, if no backend URL is configured, use current origin
    return window.location.origin;
  }

  return url;
};

export default instance;

